import { css } from 'lit';

export const style = css`
	:host {
		display: flex;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}
`;

export const resultStyle = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.head {
		flex: 0 0 30px;
		display: flex;
		align-items: center;
		flex-direction: row;
	}

	.head > * {
		height: 100%;
	}

	.head > .controls {
		flex: 0 0;
		background: var(--og-tab-panel-background-color);
		border-bottom: 1px solid var(--og-tab-border-color);
		display: flex;
		align-items: center;
		flex-direction: row;
	}

	.head > .controls > * {
		width: 25px;
	}

	.head > og-tabs {
		flex: 1 1 auto;
	}

	.body {
		flex: 1 1 auto;
		overflow: auto;
	}

	.body > * {
		height: 100%;
		overflow: hidden;
	}
`;

export const innerResultStyle = css`
	* { box-sizing: border-box }

	:host {
		display: block;
		height: 100%;
		width: 100%;
		overflow: auto;
	}

	og-splitcontainer, og-tabcontainer {
		height: 100%;
		width: 100%;
	}
`;
